export default [
  {
    path: '/b2bhub/configuracao/integracao-erp',
    name: 'integracao-erp',
    component: () => import('@/views/app/configuracao/integracaoErp/integracoesErp.vue'),
    meta: {
      pageTitle: 'Integração ERP',
      action: 'manage',
      resource: 'IntegracaoErp',
    },
  },
];
